var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeOfBuying(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50254_27174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94119 9.287H8.17454C8.50164 9.287 8.81535 9.15706 9.04665 8.92576C9.27794 8.69447 9.40788 8.38076 9.40788 8.05366C9.40788 7.72655 9.27794 7.41285 9.04665 7.18155C8.81535 6.95025 8.50164 6.82031 8.17454 6.82031H6.32452C5.95452 6.82031 5.64618 6.94365 5.46118 7.19032L2.00781 10.5203",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47656 12.9826L5.46324 12.1192C5.64824 11.8725 5.95658 11.7492 6.32658 11.7492H8.79327C9.47161 11.7492 10.0883 11.5025 10.52 11.0092L13.3566 8.29585C13.5946 8.07096 13.7335 7.76076 13.7428 7.43347C13.752 7.10619 13.6309 6.78863 13.406 6.55066C13.1811 6.31269 12.8709 6.17381 12.5436 6.16456C12.2163 6.1553 11.8988 6.27644 11.6608 6.50133L9.07077 8.90635",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38281 9.90625L5.08285 13.6063",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 6.81815V3.39661L6.82919 1.5H11.3647L12.4986 3.39661L12.4787 6.20147",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 3.39844H12.4986",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50254_27174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOfBuying);
export default __webpack_public_path__ + "static/media/typeOfBuying.2065b7831d3ef4087efcd7094fec93b1.svg";
export { ForwardRef as ReactComponent };